/**
 * Logic used to update the language selection forms in the footer with the current url.
 */
export function bindLangsFormsCurrentUrl(): void {
    document.querySelectorAll<HTMLInputElement>(".langs input[name=next]").forEach(inputEl => {
        inputEl.value = `${window.location.pathname}${window.location.search}`
    })
}
